import type { ReactNode } from 'react';
import { ErrorBanner } from '@zarya/ui';
import type { ApiError } from '@app/api/ApiError';
import { t } from '@app/i18n';
import s from '../Identities.module.css';

/**
 * Carregamento e erro **por aba** (FR-054, FR-126): uma aba fora do ar não
 * derruba as outras, e cada uma tem o seu "Tentar de novo".
 */
export interface TabStateProps {
  carregando: boolean;
  erro: ApiError | null;
  tituloErro: string;
  onRetry: () => void;
  children: ReactNode;
  /** Texto do carregando. Padrão: o genérico do catálogo. */
  rotulo?: string;
}

export function TabState({
  carregando,
  erro,
  tituloErro,
  onRetry,
  children,
  rotulo,
}: TabStateProps) {
  if (erro) {
    return <ErrorBanner error={erro} title={tituloErro} onRetry={onRetry} hideLink />;
  }
  // O padrão fica no corpo, e não na assinatura: um `rotulo = t(…)` na
  // desestruturação passa despercebido como valor dependente do locale.
  if (carregando) {
    return <p className={s.carregando}>{rotulo ?? t('identities.tab.loading')}</p>;
  }
  return <>{children}</>;
}
